import { atom } from 'recoil';
import { STORE_KEYS } from 'store/keys';

const bvnVerificationAtom = atom<{ step: 'lookup' | 'confirm' | 'verify' } | undefined>({
  key: STORE_KEYS.VERIFY_BVN,
  default: undefined
});

export default bvnVerificationAtom;
